module.exports = __webpack_public_path__ + "img/home_banner.fbf95d0f.png";